import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { LoginPage } from '#src/pages/LoginPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_noAuth/login')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
        <title>
          {intl.formatMessage({
            id: 'head.log-in-page',
            defaultMessage: 'Log In'
          })}
        </title>
      </Head>

      <LoginPage />
    </>
  );
}
